import { render, staticRenderFns } from "./Operatore.vue?vue&type=template&id=20579ae2&"
import script from "./Operatore.vue?vue&type=script&lang=js&"
export * from "./Operatore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports